var _style, _path, _g, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotCocoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92555;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#B17F4A;}\n\t.st3{fill:#FAD8E9;}\n\t.st4{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.51,94.97c-0.66,0.24-1.31,0.51-1.96,0.79c-0.07,0.03-0.82,0.3-0.82,0.36l-0.11,15.06l1.36,0.97 c0,0,2.66,2.47,3.38-3.98c0.03-0.25,0.19-0.53,0.27-0.76c0.24-0.62,0.51-1.23,0.81-1.82c0.74-1.46,1.7-2.99,3.11-3.9 c1.65-1.07,3.44-0.6,4.86,0.61c0.5,0.43,0.95,0.92,1.37,1.43c0.65,0.8,1.23,1.72,1.51,2.74c0.31,1.12,0.22,2.36,0.19,3.51 c-0.04,1.51-0.21,3.01-0.54,4.48c-0.39,1.78-1.01,3.52-1.85,5.14c-0.98,1.9-2.28,3.62-3.81,5.11c-1.87,1.82-4.06,3.27-6.4,4.4 c-1.2,0.58-2.45,1.08-3.71,1.51c-0.69,0.23-1.39,0.45-2.1,0.64c-0.38,0.1-0.76,0.2-1.14,0.29c-0.13,0.03-1.1,0.17-1.13,0.26 c3.42-11.02,6.25-25.37,5.1-40.92h-0.91c0.8-0.53,1.2-1.07,1.2-1.63c0-3.4-14.86-6.15-33.21-6.15c-18.34,0-33.21,2.75-33.21,6.15 c0,0.55,0.43,1.1,1.18,1.63h-1.11c0,0-2.87,35.99,14.94,63.72c0,0,17.6,10.24,36.92-1.17c0,0,1.77-3.01,4.09-8.27 c1.15-0.6,3.11-1.8,6.4-4.21c0,0,21.34-10.24,23.2-23.13c0.06-0.39,0.14-0.78,0.2-1.17c0.15-1.02,0.27-2.05,0.36-3.08 c0.12-1.43,0.17-2.86,0.15-4.29c-0.03-1.61-0.15-3.22-0.42-4.81c-0.27-1.59-0.69-3.16-1.35-4.63c-0.63-1.41-1.5-2.72-2.64-3.76 c-1.21-1.1-2.71-1.84-4.3-2.2c-2.07-0.47-4.25-0.33-6.32,0.06C141.86,94.19,140.68,94.54,139.51,94.97z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.32,
    y: 89.17,
    className: "st1",
    width: 1.89,
    height: 6.57
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "73.7,96.26 71.81,96.26 71.77,92.26 71.81,89.18 73.7,89.18  "
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.09,90.23c-0.87-0.53-1.26-0.97-1.48-1.25c-0.65-0.85-0.83-1.72-0.91-2.16c-0.1-0.55-0.44-2.36,0.68-4.1 c1.12-1.74,2.91-2.19,3.3-2.28c-0.39-0.36-1.43-1.45-1.71-3.19c-0.95-6.03,6.84-7.24,11.15-7.51c-0.23-0.37-0.93-1.64-0.68-3.3 c0.28-1.87,1.59-2.92,1.93-3.19c2.05-1.59,4.97-1.36,7.41-1.62c3.76-0.4,2.87-4.6,3.62-7.21c0.47-1.63,1.87-2.38,3.42-2.77 c-0.28,0.07,0.27,1.51,0.39,1.64c0.46,0.54,1.33,0.61,2,0.62c2.14,0.04,4.32,0.16,6.26,1.15c0.58,0.3,1.58,0.82,2.39,1.93 c1.01,1.39,1.13,2.87,1.14,3.53c1.31,0.25,3.11,0.7,5.12,1.59c1.87,0.83,3.23,1.43,4.55,2.84c0.52,0.56,2.04,2.22,2.5,4.89 c0.31,1.8,0,3.28-0.23,4.1c1.8,0.58,3.28,1.28,4.44,1.93c3.07,1.72,4.74,3.75,5.23,7.28c0.27,1.95,0,3.46-0.11,3.98 c-0.5,2.39-3.09,3.36-5.12,4.21c-1.76,0.73-3.42,1.16-6.71,1.71c-5.01,0.83-8.85,1.12-9.1,1.14c-8.93,0.65-18.11,0.45-26.97-0.8 C84.63,92.85,79.56,92.36,76.09,90.23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.32,117.68c0.3,1.89,0.65,3.77,1.07,5.63c1.55,6.99,3.76,14.09,6.5,20.71c1.15,2.79,2.61,7.63,5.63,8.8 c1.83,0.71,3.6,1.45,5.51,1.92c4.11,1.02,8.43,1.01,12.61,0.46c3.68-0.48,7.61-0.82,10.92-2.64c1.76-0.97,2.11-2.81,2.83-4.62 c1.82-4.58,3.69-9.15,5.25-13.83c1.69-5.07,4.54-17.64,5.24-21.9c0.7-4.25,1.51-13.98,1.51-13.98s-10.48,2.97-25.68,3.49 c-5.66,0.2-11.34-0.02-16.97-0.65c-2.82-0.32-5.63-0.74-8.42-1.29c-0.53-0.1-7.24-1.51-7.23-1.61 C75.48,104.53,76.33,111.42,77.32,117.68z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.76,74.88l-6.99,1.7c-1.38,0.34-2.78-0.51-3.11-1.9l-1.45-5.99c-0.34-1.38,0.51-2.78,1.9-3.11l6.99-1.7 c1.38-0.34,2.78,0.51,3.11,1.9l1.45,5.99C93.99,73.15,93.14,74.55,91.76,74.88z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.24,71.63l-6.81-2.3c-1.35-0.45-2.07-1.92-1.62-3.27l1.97-5.84c0.45-1.35,1.92-2.07,3.27-1.62l6.81,2.3 c1.35,0.45,2.07,1.92,1.62,3.27l-1.97,5.84C125.05,71.36,123.59,72.09,122.24,71.63z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111.15,88.99l-6.81-2.3c-1.35-0.45-2.07-1.92-1.62-3.27l1.97-5.84c0.45-1.35,1.92-2.07,3.27-1.62l6.81,2.3 c1.35,0.45,2.07,1.92,1.62,3.27l-1.97,5.84C113.96,88.72,112.5,89.45,111.15,88.99z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9913 -0.1319 0.1319 0.9913 -10.7191 15.624)",
    className: "st1",
    cx: 112.56,
    cy: 88.72,
    rx: 9.21,
    ry: 3.66
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 119.05,
    cy: 71.78,
    rx: 7.43,
    ry: 3.66
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.08,123.58c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotCocoa);
export default __webpack_public_path__ + "static/media/Hot_cocoa.cb29d1fd0c56716b6cc2c5a65175ebb3.svg";
export { ForwardRef as ReactComponent };